import * as React from "react";
export class BetBtnOuHc extends React.PureComponent {
    constructor(props) {
        super(props);
        this.textDataUat = this.props.dataUat ? this.props.dataUat.text : "bet-title-team-name";
        this.pointsDataUat = this.props.dataUat ? this.props.dataUat.points : undefined;
        this.oddDataUat = this.props.dataUat ? this.props.dataUat.odds : "bet-odds-value";
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "bet_btn-information bet_btn-information--text", "data-uat": this.textDataUat }, this.props.text),
            React.createElement("span", { className: "bet_btn-information bet_btn-information--points", "data-uat": this.pointsDataUat }, this.props.point),
            React.createElement("span", { className: "bet_btn-information bet_btn-information--odd", "data-uat": this.oddDataUat }, this.props.odd)));
    }
}
//# sourceMappingURL=BetBtnOuHc.js.map